module.exports = __webpack_public_path__ + "img/img9.dc5f43ed.svg";